import React, { useState, useEffect } from 'react';
import Layout from '../Layout/Layout';
import PageHeader from '../PageHeader/PageHeader';
import Button from '../Button/Button';
import {useErrorToast} from '../../hooks/useErrorToast';
import PageTransition from '../PageTransition/PageTransition';
import Report from '../../stacks/reports/ReportsAWS';
import CheckProgress from '../CheckProgress/CheckProgress'

const ReportScreenNew = props => {
  const [loading, setLoading] = useState(true);
  const {setErrorMsg,errorToast} = useErrorToast('');
  const [available, setAvailble] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    setErrorMsg(error)
  }, [error, setErrorMsg])


  useEffect(() => {
    async function getProgess() {
      const progress = await CheckProgress('report')
      if (progress === false) {
        setAvailble(false)
        setLoading(false)
        props.history.push('/progress');
      }
      setAvailble(true)
    }
    getProgess()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  useEffect(() => {
    async function loadReport() {
      try {
        const apiReport = Report.getInstance();
        const {report} = await apiReport.retrieve()
        console.log(`Report: ${report}`)
        window.open(report)
        setLoading(false)
        props.history.push('/progress')
      } catch (err) {
        console.log(`Report error: ${JSON.stringify(err, null, 2)}`)
        setLoading(false)
        err.message ? setError(err.message) : setError('Error!')
      }
    }
  
    if (available) {
      loadReport()
    }
  },[available, props.history]);

  return (
    <Layout product='ica'>
      <PageHeader title='Report'>
      </PageHeader>
      {errorToast !== '' &&  <Button
          small
          color='#28b536'
          click={() => props.history.push('/progress')}
        >
          CONTINUE
        </Button>
      }
      <PageTransition loading={loading} msg='Loading report information...'>
      </PageTransition>
      {errorToast}
    </Layout>
  );
};

export default ReportScreenNew;
